import styled from 'styled-components'

import { media } from 'featureSliced/shared/utils/breakpoints'

export const ItemsContainer = styled.div`
  position: relative;
  overflow-y: scroll;
  max-height: calc(100vh - 334px);
  margin-bottom: 10px;
  padding-bottom: 80px;

  /* QRM-662: the web dialog's body scrolls now, so a viewport-derived cap here
     nests a second scroller inside it and hides the last variants behind the
     80px pad. Same override AddMenuItems already carries. */
  ${media.web} {
    overflow-y: visible;
    max-height: none;
    padding-bottom: 0;
  }
`
